// A hall TV's report of a picture or film it skipped because it would not play.
// The server keeps the last one per machine for the Machines page and logs it.

export type SkippedKind = 'image' | 'video'

const SAME_ITEM_MS = 10 * 60_000
const PER_MINUTE = 6

/** A reporter that sends each item at most once in ten minutes, and six a minute in all. */
export function skipReporter(
  send: (s: { assetId: string; kind: SkippedKind }) => unknown,
  now: () => number = Date.now,
): (assetId: string, kind: SkippedKind) => void {
  const last = new Map<string, number>()
  let sentAt: number[] = []
  return (assetId, kind) => {
    const t = now()
    const was = last.get(assetId)
    if (was !== undefined && t - was < SAME_ITEM_MS) return
    sentAt = sentAt.filter((at) => t - at < 60_000)
    if (sentAt.length >= PER_MINUTE) return
    last.set(assetId, t)
    sentAt.push(t)
    try {
      void Promise.resolve(send({ assetId, kind })).catch(() => {})
    } catch {
      // A report is never worth stopping the loop for.
    }
  }
}

/** MediaError.MEDIA_ERR_ABORTED and MEDIA_ERR_NETWORK: the network's fault, not the file's. */
const NOT_THE_FILE = new Set([1, 2])

/** Whether a failed item is worth reporting: a file that will not decode or play, never a TV that is offline. */
export function skipWorthSaying(online: boolean, mediaErrorCode?: number): boolean {
  return online && !(mediaErrorCode !== undefined && NOT_THE_FILE.has(mediaErrorCode))
}
